import { filterClasses } from "@swivl-mono/helpers";
import { type ReactNode } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";

import { classNameForSideBarItem, useVisibility } from "../../Hooks/WorksheetRow.Hooks";
import { RouterWorksheetData } from "../Worksheets/Types/Worksheet.Interface";
import { SidebarLink } from "./SidebarLink";

interface SidebarSectionHeadingProps {
  openOnPath: string;
  onToggle?: () => void;
  isOpen: boolean;
  excludeMatch?: string;
  height?: number;
  hideIf?: any;
  borderBottom?: boolean;
  greyBackground?: boolean;
  groupId?: number;
  locationId?: number;
  children: ReactNode;
  items: RouterWorksheetData[];
  customizationCount?: number;
  sectionCounts?: Record<string, number>;
  sectionTo?: string;
}

export function SidebarSectionHeading(props: SidebarSectionHeadingProps) {
  const visibility = useVisibility({ hideIf: props.hideIf, groupId: props.groupId, locationId: props.locationId });
  const location = useLocation();

  const oneLevelUp = props.openOnPath.split("/").slice(0, -1).join("/");

  return (
    <>
      <Link
        to={oneLevelUp}
        onClick={(e) => {
          e.preventDefault();
          if (props.onToggle) {
            props.onToggle();
          }
        }}
        style={{
          height: (props.height || 44) + "px"
        }}
        className={filterClasses(
          classNameForSideBarItem("SidebarSectionHeading", visibility),
          "SidebarLink",
          !props.isOpen && location.pathname.includes(props.openOnPath) && "selected",
          props.borderBottom && "borderBottom",
          props.greyBackground && "greyBackground"
        )}
      >
        <div className="chit" />
        <div className="flex-1">{props.children}</div>
        {props.customizationCount != null && props.customizationCount > 0 && (
          <span
            className={filterClasses(
              "flex items-center justify-center rounded-full whitespace-nowrap",
              "bg-grey-50 text-black",
              "text-[12px] leading-none font-semibold",
              "mr-2 h-[15px] px-1.5"
            )}
          >
            {props.customizationCount}
          </span>
        )}
        {props.isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </Link>
      <div aria-expanded={props.isOpen}>
        {props.isOpen &&
          props.items &&
          props.items.map((item) => {
            const to = `${props.openOnPath}/${item.to}`;
            return (
              <SidebarLink
                groupId={props.groupId}
                locationId={props.locationId}
                height={38}
                key={to}
                hideIf={item.hideIf}
                to={to}
                indent={2}
                customizationCount={props.sectionCounts?.[props.sectionTo ? `${props.sectionTo}/${item.to}` : item.to]}
              >
                {item.label}
              </SidebarLink>
            );
          })}
      </div>
    </>
  );
}
